import type { PublicBrandingRaw, PublicLoadingConfig } from './types';

const VALID_LOADING_TYPES = ['default', 'minimal', 'pulse', 'dots'] as const;

export const parsePublicLoadingConfig = (raw: PublicBrandingRaw | null): PublicLoadingConfig => {
  const type = raw?.loading_animation_type;
  const loading_animation_type = VALID_LOADING_TYPES.includes(type as (typeof VALID_LOADING_TYPES)[number])
    ? (type as PublicLoadingConfig['loading_animation_type'])
    : 'default';

  const ms = raw?.loader_indicator_duration_ms;
  const loader_indicator_duration_ms =
    typeof ms === 'number' && Number.isFinite(ms) ? ms : 1000;

  return {
    loading_animation_type,
    loader_indicator_duration_ms,
    enable_animations: raw?.enable_animations !== false,
  };
};

export const setPublicUiBootstrap = (config: PublicLoadingConfig): void => {
  if (typeof window === 'undefined') return;
  (window as Window & { __PUBLIC_UI_CONFIG__?: PublicLoadingConfig }).__PUBLIC_UI_CONFIG__ = config;
};

export const getPublicUiBootstrap = (): PublicLoadingConfig | null => {
  if (typeof window === 'undefined') return null;
  return (window as Window & { __PUBLIC_UI_CONFIG__?: PublicLoadingConfig }).__PUBLIC_UI_CONFIG__ ?? null;
};
